// Same matching rule as App\Services\Feedback\AlertKeywordMatcher, so the dashboard highlights what triggers the alert.
const WORD_CHAR = '[\\p{L}\\p{N}_]';
const MARKUP = /(<\/?[a-z!][^>]*>|&(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]*);)/i;

const normalizeKeyword = (keyword) => {
    let normalized = String(keyword ?? '').trim();
    let quoted;

    while ((quoted = normalized.match(/^(?:"([\s\S]*)"|“([\s\S]*)”)$/))) {
        normalized = (quoted[1] ?? quoted[2] ?? '').trim();
    }

    return normalized === '"' ? '' : normalized;
};

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&');

const buildPattern = (keywords) => {
    const unique = new Map();

    (keywords ?? []).forEach((keyword) => {
        const normalized = normalizeKeyword(keyword);

        if (normalized !== '' && !unique.has(normalized.toLowerCase())) {
            unique.set(normalized.toLowerCase(), normalized);
        }
    });

    if (unique.size === 0) {
        return null;
    }

    // Longest first so "Fire alarm" wins over "Fire" in one pass instead of nesting highlights.
    const alternatives = [...unique.values()]
        .map((keyword) => escapeRegExp(keyword).replace(/\s+/g, '\\s+'))
        .sort((a, b) => b.length - a.length);

    // Lookbehind needs Safari 16.4+; an older browser must still render the feedback, just unhighlighted.
    try {
        return new RegExp(`(?<!${WORD_CHAR})(?:${alternatives.join('|')})(?:e?s)?(?!${WORD_CHAR})`, 'giu');
    } catch (error) {
        console.error('Alert keyword highlight pattern could not be compiled', error);

        return null;
    }
};

export const highlightAlertKeywords = (html, keywords) => {
    const pattern = buildPattern(keywords);

    if (pattern === null) {
        return html;
    }

    // split() with a capture group puts markup at odd indexes, text at even ones.
    return html
        .split(MARKUP)
        .map((segment, index) => (index % 2 === 0
            ? segment.replace(pattern, '<span class="text-danger font-weight-bold">$&</span>')
            : segment))
        .join('');
};
